// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"9d387847cb78378e","573":"9d387847cb78378e","888":"0b6957ca23b70b8a"}[chunkId] + ".css";
};